// extracted by mini-css-extract-plugin
export default {"shimmerRoot":"OrganiserListingPage-module__shimmerRoot___2Luwr","loadingAnimation":"OrganiserListingPage-module__loadingAnimation___1_e9a"};